<template>
  <div class="followlist">
    <div class="followlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom:0px;"
        @submit.native.prevent
      >
        <el-form-item label="设备编号">
          <el-input
            v-model.trim="formInline.inputdeviceno"
            placeholder="请输入设备编号"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            icon="el-icon-search"
            plain @click="onSubmit">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button
           type="warning"
            plain
            class="el-icon-plus"
            @click="dialogFormVisible = true"
          >新增</el-button>
        </el-form-item> -->
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <!-- 封装的 i-table组件-->
        <div class="table-page">
          <i-table
            :list="list"
            @handleSelectionChange="handleSelectionChange"
            :options="options"
            :columns="columns"
            :operates="operates"
          ></i-table>
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog
        title="新增设备信息"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followxz"
        @close="closexz"
      >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="xzdate">
            <!-- <el-input v-model.trim="form.xzdate" placeholder="请输入设备编号" maxlength="15"></el-input> -->
            <el-input v-model.trim="form.xzdate" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="xzname">
            <el-input v-model.trim="form.xzname" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="xzsec">
            <el-input v-model.trim="form.xzsec" type="textarea" :rows="3" placeholder="请输入设备描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出修改-->
      <el-dialog
        title="修改设备信息"
        :visible.sync="dialogFormEdit"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followedit"
      >
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="editdate">
            <el-input disabled v-model.trim="formedit.editdate" auto-complete="off" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="editname">
            <el-input v-model.trim="formedit.editname" auto-complete="off" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="editsec">
            <el-input
              v-model.trim="formedit.editsec"
              auto-complete="off"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false">取 消</el-button>
          <el-button type="primary" @click="submitFormEdit('formedit')" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import iTable from "@/components/iTable.vue";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      addLoading: false,
      editLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      formInline: {
        inputdeviceno: ""
      },
      options: {
        stripe: true, // 是否为斑马纹 table
        //loading: true, // 是否添加表格loading加载动画
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        mutiSelect: false // 是否支持列表项选中功能
      }, // table 的参数
      columns: [
        {
          prop: "deviceNo",
          label: "设备编号",
          align: "center"
        },
        {
          prop: "deviceName",
          label: "设备名称",
          align: "center"
        },
        {
          prop: "remark",
          label: "设备描述",
          align: "center"
        }
      ], // 需要展示的列
      operates: {
        width: 300,
        fixed: "right",
        offset: 20,
        list: [
          {
            id: "1",
            label: "修改",
            type: "primary",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.handleEdit(index, row);
            }
          },
          {
            id: "2",
            label: "删除",
            type: "danger",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.handleDelete(index, row);
            }
          },
          {
            id: "3",
            label: "测量详情",
            type: "success",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.handleTestDetail(index, row);
            }
          }
        ]
      }, // 列操作按钮

      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: ""
      },
      formLabelWidth: "120px",
      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        editdate: "",
        editname: "",
        editsec: ""
      },
      rules: {
        // 新增正则验证匹配规则
        xzdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          //可以设置双重验证标准
          //{min: 5, max:15, message: '长度在 5到 15 个字符'},
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' },
          //{ pattern: /^HC/, message: '请输入由HC开头的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],
        xzsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 50, message: "长度在 1到 50 个字符" }
        ],
        xzname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 20, message: "长度在 1到 20 个字符" }
        ],

        // 修改正则验证匹配规则
        editdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          //可以设置双重验证标准
          //{ min: 5, max:15,  message: '长度在 5到 15 个字符', },
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          // { pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_-])[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],
        editsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 50, message: "长度在 1到 50 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        editname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 20, message: "长度在 1到 20 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ]
      },
      fileFlag:false,
    };
  },
  methods: {
    // 选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },

    //点击查询
    onSubmit(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (this.formInline.inputdeviceno == "") {
        this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
      } else {
        this.getTableData(
          this.formInline.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 8)
        );
      }
    },

    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 8)
          );
        }
      }
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    },

    handleTestDetail(index, row) {
      this.formedit = Object.assign({}, row); //深拷贝数据
      var id = this.formedit.id;
      this.$router.push({ path: "/followtestdetail", query: { id: id } }); //编程式导航跳转  query传参
    },
    // 点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        console.log(index, row);
      this.listIndex = index; //记录索引
      console.log(this.listIndex);
      // this.formedit=row;//记录数据
      this.formedit = Object.assign({}, row); //深拷贝记录
      console.log(this.formedit.id);
      //将对应行所对的表格值赋给input框
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editsec", row.remark);
      this.$set(this.formedit, "editname", row.deviceName);
      console.log(this.formedit.editdate);
    },

    //点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      //正则匹配规则rules
      this.$refs[datainfo].validate(valid => {
        //判断数据是否存在
        if (valid) {
          let param = {
            id: this.formedit.id,
            remark: this.formedit.editsec,
            deviceName: this.formedit.editname,
            deviceNo: this.formedit.editdate
          };
          console.log(param);
          this.editLoading = true;
          this.$postJson("dmc/follow/edit", param)
            .then(res => {
              console.log(res);
              this.editLoading = false;
              this.dialogFormEdit = false; //关闭修改弹窗
              this.$bus.$emit("submitFormEditchange_follow"); //发送一个change事件
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
                console.log("修改成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error"
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
            })
           
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },

    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false
      })
        .then(() => {
          console.log(index, row);
          let id = row.id;
          console.log(id);
          this.$postJson("dmc/follow/deleteById/"+id).then((res) => {
          if(res.code ==200){
             this.$bus.$emit("handleDeletechange_follow"); //发送一个change事件
            console.log(res);
            this.$message({
              type: "success",
              message: res.message
            });
          }else{
            this.$message({
              type: "error",
              message: res.message
            });
          }
           
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate(valid => {
        if (valid) {
          let param = {
            remark: this.form.xzsec,
            deviceName: this.form.xzname,
            deviceNo: this.form.xzdate
          };
          console.log(param);
          //this.loading = true
          this.addLoading = true;
          this.$postJson("dmc/follow/add", param)
            .then(res => {
              //旧: dmc/follow/add
              console.log(res);
              this.addLoading = false;
              this.dialogFormVisible = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              this.$bus.$emit("submitFormchange_follow"); //发送一个change事件
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error"
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
              //this.loading = false
            })
            .catch(res => {
              this.$message({
                type: "error",
                message:res.message
              });
            });
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },

    //获取表格数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno
      };
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/follow/queryGroupFollowListWithPage", param).then(
        res => {
          console.log(res);
          //判断是否有数据
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            //this.$set(this.tableData,res.result.list)
            console.log(this.list);
            setTimeout(() => {
              this.loading = false;
            }, 500);
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 3000);
          }
        }
      );
    },

    //导入
    intoList() {
      this.dialogVisible = true;
    },

    //确认导入
    getUrl(event) {
      let file = event.target.files;
      console.log(file);
      this.fileFlag=true;//by guo 2020-8-4-15:18添加
      this.formData = new FormData();
      this.formData.append("file", file[0]);
    },

    //确认导入
    intoForm() {
      if(this.fileFlag){
        this.$postFormData(
          "dmc/propertyManagement/merchantToLead",
          this.formData
        ).then(res => {
          this.dialogVisible = false;
          this.formData={};
          this.fileFlag=false;
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.getTableData();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      }else{
        this.$message({message:'请选择文件',type:'error'})
      }
    },

    closeDialogReset() {
      this.$refs.file.value = ""; // 清空file文件
    },

    //模板下载
    downLoad() {
      window.location.href = baseURL + "dmc/api/downTemplate";
    },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    }
  },

  watch: {
    currentPage(newV, oldV) {
      console.log(newV, oldV);
      deep: true; //深度监听
    },
    //  tableData(newV,oldV) {
    //      console.log(newV,oldV);
    //      deep: true  //深度监听
    // },
    data: "onSubmit" //值可以为methods的方法
  },

  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.getTableData();
  },

  mounted() {
    //监听submitFormchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("submitFormchange_follow", () => {
      this.getTableData();
    }),
      //监听handleDeletechange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("handleDeletechange_follow", () => {
        this.getTableData();
      }),
      //监听submitFormEditchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("submitFormEditchange_follow", () => {
        this.getTableData();
      }),
      this.getTableData();
  },
  components: { iTable }
};
</script>
<style lang="scss" scoped>
.followlist {
  .followlist-m {
    padding: 10px 0 0 5px;
  }
}

// 修改element-ui默认的样式
.del {
  color: red !important;
}
.fangqu {
  color: green !important;
}
.fenye {
  padding: 30px 0;
  background: #fff;
}
//  ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

//新增的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .followxz .el-dialog {
    width: 30% !important;
  }
}

//修改的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .followedit .el-dialog {
    width: 30% !important;
  }
}
</style>


